<template>
  <v-select
      v-model="model"
      label="Safety"
      :items="items"
      item-title="key"
      item-value="value"
      :prepend-icon="props.prependIcon"
      :bg-color="model == 'true' ? '#fff000' : ''"
      :dense="props.dense"
      :density="props.dense ? 'compact' : 'default'"
      :hide-details="props.dense"
      style="width: 100%"
      :variant="globalSetting.globalTextVariant"
      @update:modelValue="props.onChange?.()"
  >
    <template v-slot:item="{ props: itemProps, item }">
      <v-list-item
          v-if="item.value == 'true'"
          base-color="#ffd000"
          :subtitle="item.raw.description"
          v-bind="itemProps"
      ></v-list-item>
      <v-list-item
          v-else
          :subtitle="item.raw.description"
          v-bind="itemProps"
      ></v-list-item>
    </template>
  </v-select>
</template>

<script setup lang="ts">

import {useGlobalSetting} from "@/lib/utils";

const globalSetting = useGlobalSetting();

const model = defineModel();

const props = defineProps({
  prependIcon: {
    type: String,
    default: '',
    required: false,
  },
  onChange: {
    type: Function,
    required: false,
  },
  dense: {
    type: Boolean,
    required: false,
    default: false,
  }
})

const items = [
  {
    key: "Alle",
    description: "alle mit Safety und ohne Safety",
    value: ""
  },
  {
    key: "Mit Safety",
    description: "alle mit Safety",
    value: "true"
  }, {
    key: "Kein Safety",
    description: "alle mit Safety",
    value: "false"
  },
]
</script>